const buildConfig = (keyword, ext = {}) => {
  return {
    label: keyword.substring(1), // 需要提示的关键字
    kind: 18, // 对应monaco.languages.CompletionItemKind.Text
    insertText: `<${keyword}></${keyword}>`, // 确认后输入的内容
    insertTextRules: 4,
    ...ext
  }
}
/**
 * freemarker官方标签
 * 数据来源：IDEA 编辑器的自动提示
 * @author Caesar Liu
 * @date 2020-11-20 15:02
 */
module.exports = [
  buildConfig('#macron', {
    insertText: [
      '<#macro ${1:name}>',
      '\t',
      '</#macro>'
    ].join('\n')
  }),
  buildConfig('#assign', {
    insertText: '<#assign ${1:variable} = ${2:value}/>'
  }),
  buildConfig('#if', {
    insertText: [
      '<#if ${1:variable} == ${2:value}>',
      '\t',
      '</#if>'
    ].join('\n')
  }),
  buildConfig('#elseif', {
    insertText: [
      '<#elseif ${1:variable} == ${2:value}>'
    ].join('\n')
  }),
  buildConfig('#else', {
    insertText: [
      '<#else>'
    ].join('\n')
  }),
  buildConfig('#function', {
    insertText: [
      '<#function ${1:name} ${2:param1} ${3:param2}>',
      '\t',
      '</#function>'
    ].join('\n')
  }),
  buildConfig('#return', {
    insertText: [
      '<#return ${1:returnValue}/>'
    ].join('\n')
  }),
  buildConfig('#list', {
    insertText: [
      '<#list ${1:sequence} as ${2:item}>',
      '\t',
      '</#list>'
    ].join('\n')
  }),
  buildConfig('#listelse', {
    insertText: [
      '<#list ${1:sequence} as ${2:item}>',
      '\t',
      '<#else>',
      '\t',
      '</#list>'
    ].join('\n')
  }),
  buildConfig('#items', {
    insertText: [
      '<#items as ${1:item}>',
      '\t',
      '</#items>'
    ].join('\n')
  }),
  buildConfig('#sep', {
    insertText: [
      '<#sep>${1:sep}</#sep>'
    ].join('\n')
  }),
  buildConfig('#attempt', {
    insertText: [
      '<#attempt>',
      '\t',
      '<#recover>',
      '\t',
      '</#attempt>'
    ].join('\n')
  }),
  buildConfig('#recover', {
    insertText: '<#recover>'
  }),
  buildConfig('#break', {
    insertText: '<#break/>'
  }),
  buildConfig('#compress', {
    insertText: [
      '<#compress>',
      '\t',
      '</#compress>'
    ].join('\n')
  }),
  buildConfig('#escape', {
    insertText: [
      '<#escape identifier as expression>',
      '\t',
      '</#escape>'
    ].join('\n')
  }),
  buildConfig('#noescape'),
  // buildConfig('#flush'),
  // buildConfig('#global'),
  // buildConfig('#import'),
  // buildConfig('#include'),
  buildConfig('#t', {
    insertText: '<#t/>'
  }),
  buildConfig('#lt', {
    insertText: '<#lt/>'
  }),
  buildConfig('#rt', {
    insertText: '<#rt/>'
  }),
  buildConfig('#nt', {
    insertText: '<#nt/>'
  }),
  buildConfig('#noparse'),
  // buildConfig('#recurse'),
  // buildConfig('#visit'),
  buildConfig('#setting', {
    insertText: '<#setting ${1:variable} = ${2:value}/>'
  }),
  buildConfig('#stop', {
    insertText: '<#stop ${1:reason}/>'
  }),
  buildConfig('#switch', {
    insertText: [
      '<#switch ${1:variable}>',
      '\t',
      '</#switch>'
    ].join('\n')
  }),
  buildConfig('#case', {
    insertText: [
      '<#case ${1:variable}>'
    ].join('\n')
  }),
  buildConfig('#default', {
    insertText: [
      '<#default>'
    ].join('\n')
  }),
  buildConfig('#switchcase', {
    insertText: [
      '<#switch ${1:variable}>',
      '\t<#case ${2:refValue1}>',
      '\t\t<#break>',
      '\t<#case ${3:refValue2}>',
      '\t\t<#break>',
      '\t<#default>',
      '</#switch>'
    ].join('\n')
  })
]
